module.exports = __webpack_public_path__ + "static/media/abcd.7a0326c1.png";